module.exports = __webpack_public_path__ + "static/media/rpm.7086be72.svg";